import React, { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSpecialHolidays } from 'reducks/calendar/selectors'
import { State } from 'index'
import { HolidayArrowButton, HolidayCalendar, HolidayLabel } from 'components/Calendar/index'
import styles from 'styles/components/calendar.module.scss'
import { Spacer } from 'components/Utility'
import { OrangeButton, TextButton } from 'components/Button'
import isSameDay from 'date-fns/isSameDay'
import { parseToDate } from 'lib/helper'
import { SpecialHolidayType } from 'types/calendar'
import { OFFICIAL_HOLIDAY_URL } from 'constants/urls'
import { FlexRow } from 'components/Flex'
import { saveSpecialHolidays } from 'reducks/calendar/operations'

const HolidayCalendarContainer: FC = () => {
  const dispatch = useDispatch()

  const specialHolidays: SpecialHolidayType[] = useSelector((state: State) => getSpecialHolidays(state))

  const [activeDates, setActiveDates] = useState<Date[]>([])
  const [currentMonth, setCurrentMonth] = useState<Date>(new Date())

  const handleCurrentMonth = useCallback((month: Date) => setCurrentMonth(month), [setCurrentMonth])

  const selectDate = useCallback(
    (date: Date) => {
      setActiveDates((prevState) => {
        if (prevState.some((activeDate) => isSameDay(activeDate, date))) {
          return prevState.filter((activeDate) => !isSameDay(activeDate, date))
        } else {
          return [...prevState, date]
        }
      })
    },
    [setActiveDates]
  )

  const openOfficialHolidayPage = useCallback(() => {
    window.open(OFFICIAL_HOLIDAY_URL, '_blank')
  }, [])

  useEffect(() => {
    if (!specialHolidays) return

    setActiveDates([
      ...specialHolidays.map((specialHoliday) => {
        return parseToDate(specialHoliday.date)
      }),
    ])
  }, [specialHolidays])

  return (
    <>
      <div className={styles.calendar__monthly__header}>
        <HolidayArrowButton
          currentMonth={currentMonth}
          handleCurrentMonth={handleCurrentMonth}
          label={'前月'}
          type={'prev'}
        />
        <HolidayLabel currentMonth={currentMonth} />
        <HolidayArrowButton
          currentMonth={currentMonth}
          handleCurrentMonth={handleCurrentMonth}
          label={'翌月'}
          type={'next'}
        />
      </div>
      <Spacer size={16} />
      <HolidayCalendar activeDates={activeDates} currentMonth={currentMonth} selectDate={selectDate} />
      <Spacer size={16} />
      <OrangeButton
        label={'保存する'}
        onClick={() => dispatch(saveSpecialHolidays(activeDates))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <FlexRow justifyContent={'center'}>
        <TextButton label={'内閣府の祝日を確認する'} onClick={openOfficialHolidayPage} />
      </FlexRow>
    </>
  )
}

export default HolidayCalendarContainer
